<template>
        <div class="jumbotron">
            <div class="school" v-if="user.user_instance.provider">
<!--                <span v-if="user.user_instance.provider.provider_logo" class="school_logo">-->
<!--                    <img :src="user.user_instance.provider.provider_logo"/>-->
<!--                </span>-->
                <div class="school_info">
                    <h3>{{evaluation_title}}</h3>
                    {{user.user_instance.provider.leverandor}}
                </div>
            </div>

            <div class="user_info" v-if="!preview" @click="userClickHandler" style="cursor:pointer">
                <span><b> {{user.user_instance.user.firstname}} {{user.user_instance.user.lastname}}</b></span>
                <span>{{user.user_instance.user.email}}</span>
            </div>
        </div>

</template>

<script>
    export default {
        name: "Header",
        props: {
            user: null,
            evaluation_title: {
                type: String,
                default: ''
            },
            preview: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            userClickHandler(){
                this.$emit('clicked-user');
            }
        }
    }
</script>


<style lang="scss" scoped>
    @import "../styles/components/header.scss";
</style>

